// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-remarks.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-remarks/taf-remarks.js';

mount([g0]);
